var CustomEvents = /** @class */ (function () {
    function CustomEvents() {
        this.events = {};
    }
    /**
     * Add an event listener for a given event type.
     */
    CustomEvents.prototype.addEventListener = function (type, callback) {
        if (!this.events[type]) {
            this.events[type] = [];
        }
        this.events[type].push(callback);
    };
    /**
     * Remove a specific listener for an event type.
     */
    CustomEvents.prototype.removeEventListener = function (type, callback) {
        var listeners = this.events[type];
        if (!listeners)
            return;
        this.events[type] = listeners.filter(function (fn) { return fn !== callback; });
        if (this.events[type].length === 0) {
            delete this.events[type];
        }
    };
    /**
     * Dispatch an event to all listeners of the specified type.
     */
    CustomEvents.prototype.dispatchEvent = function (type, data) {
        var listeners = this.events[type];
        if (!listeners)
            return;
        for (var i = 0; i < listeners.length; i++) {
            try {
                listeners[i](data);
            }
            catch (err) {
                console.error("Error in listener for event \"".concat(type, "\":"), err);
            }
        }
    };
    /**
     * Remove all listeners for a specific event or all events.
     */
    CustomEvents.prototype.removeAllListeners = function (type) {
        if (type) {
            delete this.events[type];
        }
        else {
            this.events = {};
        }
    };
    return CustomEvents;
}());
var customEventHandler = new CustomEvents();
var _skipTableDuplicate = false;
export function getSkipTableDuplicate() { return _skipTableDuplicate; }
export function setSkipTableDuplicate(val) { _skipTableDuplicate = val; }
export default customEventHandler;
